import api from '@/services/api.service';

import { TokenService } from '@/services/storage.service';
import { localStore } from '@/services/local.storage';
import store from '@/store';

import { required, minLength } from 'vuelidate/lib/validators';

export default {
    name: 'Login',
    components: {},
    props: [],
    data() {
        return {
            log: { email: '', password: '' },
            errors: '',
            msg: '',
            submitStatus: null,
            loader: false
        };
    },
    created() {},
    computed: {},
    validations: {
        log: {
            email: {
                required,
                minLength: minLength(4)
            },
            password: {
                required
            }
        }
    },
    mounted() {},
    methods: {
        makeToast(message = '', title = 'Alert', variant = 'warning') {
            this.toastCount++;
            this.$root.$bvToast.toast(message, {
                title: title,
                variant: variant,
                autoHideDelay: 3000
            });
        },
        async login() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR';
            } else {
                this.loader = true;
                this.msg = '';
                this.errors = '';
                let response = await api.post('/login', this.log);
                if (!response) this.makeToast('Something went to wrong please try again', 'Alert', 'danger', 6000);

                if (response.status == 'success') {
                    const token = response.data.token;
                    TokenService.saveToken(token);
                    api.setHeader();
                    store.state.user.loggedIn = true;
                    if (response.data.role.role != 'agent' && response.data.role.role != 'vendor') {
                        store.state.user.isAdmin = true;
                        localStore.saveLocalStorage('role', btoa(response.data.role.role));
                        // localStore.saveLocalStorage('role', btoa('role1'));
                        localStore.saveLocalStorage('user_id', btoa(response.data.id));
                        localStore.saveLocalStorage('user_name', btoa(response.data.first_name.charAt(0) + response.data.last_name.charAt(0) ));
                        this.makeToast('Login Successful', 'Success', 'success', 6000);
                        this.$router.push({ name: 'Admin Dashboard' });
                    } else if (response.data.role.role == 'agent') {
                        store.state.user.isAgent = true;
                        localStore.saveLocalStorage('role', btoa('agent'));
                        localStore.saveLocalStorage('user_id', btoa(response.data.id));
                        localStore.saveLocalStorage('user_name', btoa(response.data.first_name.charAt(0) + response.data.last_name.charAt(0) ));
                        this.makeToast('Login Successful', 'Success', 'success', 6000);
                        this.$router.push({ name: 'Agent Dashboard' });
                    } else if (response.data.role.role == 'vendor') {
                        store.state.user.isVendor = true;
                        localStore.saveLocalStorage('role', btoa('vendor'));
                        localStore.saveLocalStorage('user_id', btoa(response.data.id));
                        localStore.saveLocalStorage('user_name', btoa(response.data.first_name.charAt(0) + response.data.last_name.charAt(0) ));
                        this.makeToast('Login Successful', 'Success', 'success', 6000);
                        this.$router.push({ name: 'Vendor Dashboard' });
                    }

                } else {
                    if (response.errors) {
                        for (var error in response.errors)
                            this.makeToast(response.errors[error], 'Alert', 'danger', 6000);
                        this.loader = false;
                    } else {
                        this.msg = response.message;
                        this.loader = false;
                    }
                }
            }
        },
        forgotPassword()
        {
            this.$router.push({name:"Forgot Password"});
        }
    }
};
